import { BIND_POLICY, BindPolicyInput, BindPolicyResponse } from "src/configs/APISchemas/BindPolicy";
import { GraphQLRequest } from "src/helpers/GraphQLRequest";

export async function bindPolicy(input: BindPolicyInput) {
    const mutation = BIND_POLICY(input);

    const response = await GraphQLRequest<BindPolicyResponse>(mutation);

    return response.bindPolicy
}
